export default __webpack_public_path__ + "static/media/hydro-power.bdc490f3.png";